module.exports = __webpack_public_path__ + "static/media/maroof-title.45579c80.jpg";